// Campus photo for /colleges/florida-state-university: CC0 1.0, by Ernie Stephens, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AWestcott_Building_and_fountain_at_Florida_State_University.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/florida-state-university/; credited under the photo.
const photo = {
    "slug": "florida-state-university",
    "alt": "The Westcott Building and its fountain at Florida State University in Tallahassee, Florida",
    "src": "/colleges/florida-state-university/campus-1600.webp",
    "srcSmall": "/colleges/florida-state-university/campus-800.webp",
    "srcMid": "/colleges/florida-state-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/florida-state-university/og.jpg",
    "title": "Westcott Building and fountain at Florida State University",
    "author": "Ernie Stephens",
    "license": "CC0 1.0",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AWestcott_Building_and_fountain_at_Florida_State_University.jpg",
    "read": "2026-10-02"
};

export default photo;
